import { useMerchantOnboardingUpdates } from '@/entities/merchant';
import { useAccessSourceUpdates } from '@/entities/practice-member';
import { useSessionChargeUpdates } from '@/entities/session-charge';
import { useSubscriptionUpdates } from '@/entities/subscription';

// Mounted outside <Suspense> so a suspending route cannot tear the subscription down, and inside
// QueryProvider because these hooks invalidate through the query client.
export function WebSocketSubscriptions() {
    useSubscriptionUpdates();
    useAccessSourceUpdates();
    useSessionChargeUpdates();
    useMerchantOnboardingUpdates();

    return null;
}
